import React, { useEffect, useRef } from 'react'
import clsx from 'clsx'

import { RouterItemProps } from '../../types'
import styles from './styles.module.scss'

export default function ({
  image,
  text,
  href,
  title,
  styleClassName = 'carousel',
  className = '',
}: RouterItemProps) {
  const anchorRef = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    const anchor = anchorRef.current
    if (!anchor || !href) return
    const handlePreventedClick = (e: MouseEvent) => {
      if (e.defaultPrevented) {
        window.location.href = href // Manual navigation
      }
    }
    anchor.addEventListener('click', handlePreventedClick)
    return () => {
      anchor.removeEventListener('click', handlePreventedClick)
    }
  }, [href])

  if (!href) return null

  return (
    <div
      className={clsx(
        styleClassName,
        styleClassName === 'grid' ? styles.item : ''
      )}
    >
      <a
        ref={anchorRef}
        href={href}
        title={title || text}
        className={clsx(className, styles.anchor)}
      >
        {image && <div className={styles.image}>{image}</div>}
        {text}
      </a>
    </div>
  )
}
